// Generated by CoffeeScript 2.7.0
var ProposeTime;

import FieldMixins from 'trunks/vue/admin/components/fields/mixins/field_mixin.js';

import BaseField from './field.js';

import SerialNumberFieldMixin from './mixin.js';

import {
  FIELD_GROUPS
} from './constants.js';

export default ProposeTime = Vue.extend({
  mixins: [FieldMixins, SerialNumberFieldMixin],
  components: {
    FieldView: BaseField
  },
  template: `<FieldView
  ref="fieldView"
  :editing='editing'
  :field="field"
>
  <Dropdown
    slot='optionbar'
    :optionGroups='fieldGroups'
    :initValue='currentGroup'
    :optionGroupsFixed='true'
    class="custom-dropdown ml-3"
    style="width: 10rem"
    @change='optionChanged'
  >
    <template slot='value-template' slot-scope='{ option }'>
      <span>{{ option.label }}</span>
    </template>
    <template slot='option-template' slot-scope='{ option }'>
      <div class="justify-between">
        <span>{{ option.label }}</span>
        <span class="helper-text">{{ option.description }}</span>
      </div>
    </template>
  </Dropdown>
  <template slot='description'>
    <span>在编号中插入提交表单/流程的日期</span>
  </template>
  <template slot='content'>
    <div>{{ _getDescriptionOfField() }}</div>
  </template>
</FieldView>`,
  data: function() {
    return {
      currentGroup: null
    };
  },
  computed: {
    fieldGroups: function() {
      return [
        {
          options: _.map(FIELD_GROUPS,
        (option) => {
            return {
              ...option,
              type: this.field.type
            };
          })
        }
      ];
    }
  },
  watch: {
    fieldGroups: {
      handler: function() {
        var _option, options;
        options = this.fieldGroups[0].options;
        _option = _.find(options, (option) => {
          return option.params.rule === this.field.settings.rule;
        });
        if (!_option) {
          _option = _.first(options);
        }
        this.field.settings.rule = _option.params.rule;
        return this.currentGroup = _option;
      },
      immediate: true
    }
  },
  methods: {
    optionChanged: function(option) {
      this.field.settings.rule = option.params.rule;
      return this.currentGroup = option;
    },
    _getDescriptionOfField: function() {
      var ref;
      return `[${((ref = this.currentGroup) != null ? ref.label : void 0) || ""}]`;
    }
  }
});
